/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';

function Spinner({ size }: any) {
  return <div className={`spinner ${size === 'small' ? 'small-spinner' : ''}`} />;
}

export default Spinner;
